var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKayboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 34,
    viewBox: "0 0 57 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2139_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6165 10.6473H47.9439C48.6513 10.6473 49.2364 10.0826 49.2364 9.38102C49.2364 8.67943 48.66 8.11475 47.9439 8.11475H46.6165C45.9091 8.11475 45.324 8.67943 45.324 9.38102C45.324 10.0826 45.9004 10.6473 46.6165 10.6473Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5428 8.11475H36.8967C36.1894 8.11475 35.6042 8.67943 35.6042 9.38102C35.6042 10.0826 36.1806 10.6473 36.8967 10.6473H39.5428C40.2502 10.6473 40.8353 10.0826 40.8353 9.38102C40.8353 8.67943 40.2589 8.11475 39.5428 8.11475Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.823 8.11475H27.1769C26.4696 8.11475 25.8845 8.67943 25.8845 9.38102C25.8845 10.0826 26.4608 10.6473 27.1769 10.6473H29.823C30.5304 10.6473 31.1155 10.0826 31.1155 9.38102C31.1155 8.67943 30.5391 8.11475 29.823 8.11475Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4571 8.11475C16.7498 8.11475 16.1647 8.67943 16.1647 9.38102C16.1647 10.0826 16.741 10.6473 17.4571 10.6473H20.1032C20.8106 10.6473 21.3957 10.0826 21.3957 9.38102C21.3957 8.67943 20.8193 8.11475 20.1032 8.11475H17.4571Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3922 10.6473C11.0996 10.6473 11.6847 10.0826 11.6847 9.38102C11.6847 8.67943 11.1083 8.11475 10.3922 8.11475H9.06482C8.35745 8.11475 7.77234 8.67943 7.77234 9.38102C7.77234 10.0826 8.34871 10.6473 9.06482 10.6473H10.3922Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6165 18.262H47.9439C48.6513 18.262 49.2364 17.6973 49.2364 16.9958C49.2364 16.2942 48.66 15.7295 47.9439 15.7295H46.6165C45.9091 15.7295 45.324 16.2942 45.324 16.9958C45.324 17.6973 45.9004 18.262 46.6165 18.262Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5428 15.738H36.8967C36.1894 15.738 35.6042 16.3027 35.6042 17.0043C35.6042 17.7059 36.1806 18.2706 36.8967 18.2706H39.5428C40.2502 18.2706 40.8353 17.7059 40.8353 17.0043C40.8353 16.3027 40.2589 15.738 39.5428 15.738Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.823 15.738H27.1769C26.4696 15.738 25.8845 16.3027 25.8845 17.0043C25.8845 17.7059 26.4608 18.2706 27.1769 18.2706H29.823C30.5304 18.2706 31.1155 17.7059 31.1155 17.0043C31.1155 16.3027 30.5391 15.738 29.823 15.738Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4571 15.738C16.7498 15.738 16.1647 16.3027 16.1647 17.0043C16.1647 17.7059 16.741 18.2706 17.4571 18.2706H20.1032C20.8106 18.2706 21.3957 17.7059 21.3957 17.0043C21.3957 16.3027 20.8193 15.738 20.1032 15.738H17.4571Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3922 18.262C11.0996 18.262 11.6847 17.6973 11.6847 16.9958C11.6847 16.2942 11.1083 15.7295 10.3922 15.7295H9.06482C8.35745 15.7295 7.77234 16.2942 7.77234 16.9958C7.77234 17.6973 8.34871 18.262 9.06482 18.262H10.3922Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0035 23.3528H9.05609C8.34872 23.3528 7.76361 23.9175 7.76361 24.6191C7.76361 25.3206 8.33999 25.8853 9.05609 25.8853H11.0035C11.7109 25.8853 12.296 25.3206 12.296 24.6191C12.296 23.9175 11.7196 23.3528 11.0035 23.3528Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8065 23.3528C17.0991 23.3528 16.514 23.9175 16.514 24.6191C16.514 25.3206 17.0904 25.8853 17.8065 25.8853H39.1848C39.8922 25.8853 40.4773 25.3206 40.4773 24.6191C40.4773 23.9175 39.9009 23.3528 39.1848 23.3528H17.8065Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9965 23.3528C45.2891 23.3528 44.704 23.9175 44.704 24.6191C44.704 25.3206 45.2804 25.8853 45.9965 25.8853H47.9439C48.6513 25.8853 49.2364 25.3206 49.2364 24.6191C49.2364 23.9175 48.66 23.3528 47.9439 23.3528H45.9965Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8826 0.5H7.11736C3.19626 0.5 0 3.63145 0 7.47304V26.5184C0 30.3686 3.19626 33.4914 7.11736 33.4914H49.8826C53.8125 33.4914 57 30.36 57 26.5184V7.47304C57 3.62289 53.8037 0.5 49.8826 0.5ZM54.4238 26.5184C54.4238 28.9739 52.389 30.9675 49.8826 30.9675H7.11736C4.611 30.9675 2.57622 28.9739 2.57622 26.5184V7.47304C2.57622 5.0175 4.611 3.02398 7.11736 3.02398H49.8826C52.389 3.02398 54.4238 5.0175 54.4238 7.47304V26.5184Z",
    className: "color1Fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2139_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 33,
    className: "baseColor2Fill",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKayboardIcon);
export default __webpack_public_path__ + "static/media/kayboard-icon.8c973c7cacdba9c0ba90c169eb4730d2.svg";
export { ForwardRef as ReactComponent };